import * as yup from "yup";
import { stringRequired } from "../fields/index.js";

export default yup.object().shape({
    campaignResponseTypeReferenceId: stringRequired("This information is required")
});
